import { useReveal } from '@/lib/useReveal';
import { Section, Container, Display, Lead, Pill, CtaLink } from '@/components/system';

/**
 * Price + close. One plan, stated plainly (Brand voice: qué es, qué hace, qué cuesta).
 * Price lives in CONTENT_MASTER §2.7 — do not change the number here.
 */
export function FinalCTA() {
  const ref = useReveal<HTMLElement>();
  return (
    <Section tone="grey" ref={ref}>
      <Container>
        <div className="rounded-[32px] bg-white px-8 py-16 sm:px-12 sm:py-20 text-center">
          <p data-reveal className="text-brand font-semibold text-base sm:text-lg mb-4">Plan Estándar</p>
          <Display data-reveal size="lg">
            Gratis tus primeros 6 meses.
            <br />
            Después, $600 al año.
          </Display>
          <Lead data-reveal className="mt-6 mx-auto max-w-2xl">
            Todas las funciones, todas las apps, todas tus sucursales. Un solo plan, sin niveles
            ni sorpresas — y sin tarjeta de crédito para empezar.
          </Lead>
          <div data-reveal className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8">
            <Pill to="/plataforma">Solicita una demo</Pill>
            <CtaLink to="/plataforma#planes">Ver qué incluye</CtaLink>
          </div>
          <p data-reveal className="mt-8 text-text-tertiary text-sm">
            ¿Operación grande o transitaria? Pregunta por la <span className="text-text-secondary font-medium">Suite Empresarial</span>.
          </p>
        </div>
      </Container>
    </Section>
  );
}
